"use client";

import React from "react";
import dynamic from "next/dynamic";
import { Loader2 } from "lucide-react";
import { SearchTypes } from "@/constants/filters";
const LazyLocationMap = dynamic(() => import("./LocationMap"), {
  ssr: false,
  loading: () => <div className="flex items-center justify-center h-[350px]">
      <Loader2 className="h-6 w-6 animate-spin text-zinc-600" />
    </div>
});
const LocationMapCaller = React.memo(function LocationMapCaller({
  businessType,
  selectedCodes,
  onSelectionChange,
  showBadges,
  selectedNames,
  showCount,
  countByCode
}: {
  businessType?: SearchTypes;
  selectedCodes: string[];
  onSelectionChange: (codes: string[], nameByCode?: Map<string, string>) => void;
  showBadges?: boolean;
  selectedNames?: Map<string, string>;
  showCount?: boolean;
  countByCode?: Map<string, number>;
}) {
  return <LazyLocationMap businessType={businessType} selectedCodes={selectedCodes} onSelectionChange={onSelectionChange} showBadges={showBadges} selectedNames={selectedNames} showCount={showCount} countByCode={countByCode} />;
});
export default LocationMapCaller;